import { Layout } from 'core/components/ui';
import styled from 'styled-components';

export const HeaderWrapper = styled(Layout.Header)`
  display: flex;
  align-items: center;
  justify-content: start;
  position: fixed;
  z-index: 100;
  width: 100%;

  &:before {
    bottom: 0;
    content: '';
    height: 0.2rem;
    left: 0;
    position: absolute;
    right: 0;
  }

  > a {
    padding-right: 16px;
  }
`;

export const LogoBox = styled.a`
  display: flex;
  align-items: center;

  .img-logo {
    height: 23px;
  }

  .header-logo-title {
    letter-spacing: 0.1em;
    color: #fff;
    font-weight: bold;
    line-height: 1;
    padding-left: 4px;
    align-self: flex-start;
  }
`;
